import { createPopper } from '@popperjs/core'

export default {
  beforeMount(el, binding) {
    const position = binding.arg || 'top'

    // Armazena o binding no elemento para acesso reativo
    el.tooltipBinding = binding

    const createTooltip = (text, html = false) => {
      if (!text) return

      const tooltip = document.createElement('div')
      tooltip.className = 'z-50 p-3 text-black bg-white font-medium rounded-md text-xs shadow-xl'
      tooltip.style.opacity = '0'
      tooltip.style.transition = 'opacity 0.2s ease'

      if (Array.isArray(text)) {
        text.forEach(t => {
          const p = document.createElement('p')
          p.textContent = t
          tooltip.appendChild(p)
        })
      } else if (html) {
        tooltip.innerHTML = text
      } else {
        tooltip.innerText = text
      }

      const arrow = document.createElement('div')
      arrow.className = 'tooltip-arrow bg-white shadow-xl'
      tooltip.appendChild(arrow)

      document.body.appendChild(tooltip)

      const popperInstance = createPopper(el, tooltip, {
        placement: position,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 12],
            },
          },
          {
            name: 'arrow',
            options: {
              element: arrow,
              padding: 5,
            },
          },
        ],
      })

      el.tooltipData = { tooltip, popperInstance }
    }

    const showTooltip = () => {
      // Usa o binding armazenado no elemento (sempre atualizado)
      const { text, enabled = true, html = false } = el.tooltipBinding.value || {}

      if (!enabled) return
      if (!el.tooltipData) createTooltip(text, html)

      el.tooltipData.tooltip.style.opacity = '1'
      requestAnimationFrame(() => {
        el.tooltipData.popperInstance.update()
      })
    }

    const hideTooltip = () => {
      if (el.tooltipData) {
        el.tooltipData.tooltip.style.opacity = '0'
        setTimeout(() => {
          if (el.tooltipData) {
            el.tooltipData.popperInstance.destroy()
            el.tooltipData.tooltip.remove()
            el.tooltipData = null
          }
        }, 200)
      }
    }

    el.addEventListener('mouseenter', showTooltip)
    el.addEventListener('mouseleave', hideTooltip)
    el.addEventListener('focus', showTooltip)
    el.addEventListener('blur', hideTooltip)

    el.tooltipHandlers = { showTooltip, hideTooltip }
  },

  updated(el, binding) {
    el.tooltipBinding = binding

    const { text, enabled = true, html = false } = binding.value || {}

    if (el.tooltipData && !enabled) {
      if (el.tooltipHandlers) {
        el.tooltipHandlers.hideTooltip()
      }
    }

    if (el.tooltipData && enabled && text) {
      if (Array.isArray(text)) {
        el.tooltipData.tooltip.innerHTML = ''
        text.forEach(t => {
          const p = document.createElement('p')
          p.textContent = t
          el.tooltipData.tooltip.appendChild(p)
        })
        const arrow = document.createElement('div')
        arrow.className = 'tooltip-arrow bg-white shadow-xl'
        el.tooltipData.tooltip.appendChild(arrow)
      } else if (html) {
        el.tooltipData.tooltip.innerHTML = text
      } else {
        el.tooltipData.tooltip.innerText = text
      }
      el.tooltipData.popperInstance.update()
    }
  },

  unmounted(el) {
    if (el.tooltipHandlers) {
      el.removeEventListener('mouseenter', el.tooltipHandlers.showTooltip)
      el.removeEventListener('mouseleave', el.tooltipHandlers.hideTooltip)
      el.removeEventListener('focus', el.tooltipHandlers.showTooltip)
      el.removeEventListener('blur', el.tooltipHandlers.hideTooltip)
    }

    if (el.tooltipData) {
      el.tooltipData.popperInstance.destroy()
      el.tooltipData.tooltip.remove()
      el.tooltipData = null
    }
  },
}
